import * as configureSolarApi from '../store/configureSolarApi';

const clientConfigurationReducer = (state = {
    clientConfiguration: [],
    ...configureSolarApi.initialState
}, action) => {
    switch (action.type) {
        case "RECEIVE_Data_clientConfigurationReducer":
            return { ...state, clientConfiguration: action.value, isLoaded: true };
    }

    return configureSolarApi.switchCaseForDefaultActionTypesForReducers(action, state);
};
export default clientConfigurationReducer;
